import { render, staticRenderFns } from "./MeasureList.vue?vue&type=template&id=1400ab20&scoped=true"
import script from "./MeasureList.vue?vue&type=script&lang=js"
export * from "./MeasureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1400ab20",
  null
  
)

export default component.exports